import { render } from "./HeaderBuildings.vue?vue&type=template&id=2fdd2330"
import script from "./HeaderBuildings.vue?vue&type=script&lang=js"
export * from "./HeaderBuildings.vue?vue&type=script&lang=js"

import "./HeaderBuildings.vue?vue&type=style&index=0&id=2fdd2330&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__